// extracted by mini-css-extract-plugin
module.exports = {"outer":"_24FGq","leftWrapper":"VAkqS","heading":"W1oY6","subHeading":"_3sgFJ"};